<template>
    <div class="showName-mask">
        <Dialog :title="$t('showName')" :isShow="true" :icon="EDCONFIG.IS_SDK ? '' : 'newEdrawIcon'" @close="closeModal">
            <div class="showName-showbox">
                <div class="region-box">
                    <div class="region-thead">{{ $t("showName") }}</div>
                    <div class="checkbox-thead">
                        <Checkbox :value="checkAll" @click.prevent.native="handleCheckAll">
                            {{ checkAll ? $t("selectAll2") : $t("selectAll") }}
                        </Checkbox>
                    </div>
                </div>
                <div class="region-box" v-for="(item, idx) in copyRegionData" :key="idx">
                    <p class="region-name">{{ item.name }}</p>
                    <div class="checkbox-box">
                        <Checkbox v-model="item.label.show" />
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="confirm">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "@/app/components/Modals/Dialog.vue";
    import cloneDeep from "lodash/cloneDeep";
    @Component({
        components: {
            Dialog,
        },
    })
    export default class ShowName extends Vue {
        copyRegionData = [];
        checkAll = true;

        created() {
            this.copyRegionData = cloneDeep(this.regionData);
            this.isSelectAll();
        }
        set regionData(newVal) {
            this.$store.commit("setEChartState", {
                type: "mapRegionData",
                data: newVal,
            });
        }
        get regionData() {
            return this.$store.state.echart.mapRegionData || [];
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        confirm() {
            this.regionData = this.copyRegionData;
            window["_view"].processChartCMD("mapRegionData", { data: this.regionData });
            this.closeModal();
        }
        @Watch("copyRegionData", { immediate: true, deep: true })
        isSelectAll() {
            this.checkAll = true;
            // 获取是否全选状态
            for (let item of this.copyRegionData) {
                if (!item.label.show) {
                    this.checkAll = false;
                    break;
                }
            }
        }
        handleCheckAll() {
            this.copyRegionData.forEach((item) => {
                item.label.show = !this.checkAll;
            });
            this.checkAll = !this.checkAll;
        }
    }
</script>

<style lang="stylus">
    .showName-mask
        modal-mask()
        .dialog-container-component
          .dialog-title
              .item-icon
                  left 14px
              .title-text
                  left 44px
        .showName-showbox
            margin 16px 24px 0
            padding-bottom 16px
            overflow auto
            width 480px
            height 344px
            overflow auto
            border 1px solid var(--border-color-box-6)
            box-sizing border-box
            border-radius 6px
            line-height 16px
            .region-thead
                display inline-block
                text-align center
                width 50%
                margin 0 18% 0 4%
                font-weight bold
            .checkbox-thead
                display inline-block
                // text-align center
                width 28%
                font-weight bold
                .ivu-checkbox-wrapper
                  display flex
                  align-items center
                  .ivu-checkbox
                    margin-right 8px
                    &:not(.ivu-checkbox-checked)
                        .ivu-checkbox-inner
                            background-color var(--bg-color-tertiary)
            .region-box
                margin-top 15px
                display flex
                align-items center
                .region-name
                    display inline-block
                    text-align center
                    width 50%
                    margin 0 18% 0 4%
                .checkbox-box
                    // text-align center
                    display inline-block
                    width 28%
                    .ivu-checkbox
                        &:not(.ivu-checkbox-checked)
                            .ivu-checkbox-inner
                                background-color var(--bg-color-tertiary)
            .ivu-checkbox-wrapper
                margin-right 0
              .ivu-checkbox-inner
                width 16px
                height 16px
                box-sizing border-box
              .ivu-checkbox-checked
                .ivu-checkbox-inner
                  &:after
                    top 2px
                    left 5px
        .dialog-btnbox-normal
            margin-top 24px
</style>

<i18n>
{
  "zh": {
    "showName": "显示地区名称",
    "confirm": "确定",
    "cancel": "取消",
    "region": "地区",
    "display": "显示",
    "selectAll": "全选",
    "selectAll2": "取消全选"
  },
  "en": {
    "showName": "Show Region Name",
    "confirm": "OK",
    "cancel": "Cancel",
    "region": "Region",
    "display": "Show",
    "selectAll": "Select all",
    "selectAll2": "Cancel"
  },
  "fr": {
    "showName": "Afficher le nom de zone",
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "region": "Région",
    "display": "Afficher",
    "selectAll": "tout sélectionner",
    "selectAll2": "tout déselectionner"
  },
  "pt": {
    "showName": "Mostrar nome da região",
    "confirm": "OK",
    "cancel": "Cancelar",
    "region": "Região",
    "display": "Mostrar",
    "selectAll": "selecionar tudo",
    "selectAll2": "Desmarque todos"
  },
  "de": {
    "showName": "Bezirksname anzeigen",
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "region": "Bezirk",
    "display": "Anzeigen",
    "selectAll": "Alle wählen",
    "selectAll2": "Alles wiederufen"
  },
  "es": {
    "showName": "Mostrar nombre de área",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "region": "Región",
    "display": "Mostrar",
    "selectAll": "seleccionar todo",
    "selectAll2": "Deselecciona todo"
  },
  "jp": {
    "showName": "地域を表示",
    "confirm": "確認",
    "cancel": "キャンセル",
    "region": "地域",
    "display": "表示",
    "selectAll": "すべて選択",
    "selectAll2": "すべて選択解除"
  },
  "tw": {
    "showName": "顯示地區名稱",
    "confirm": "確定",
    "cancel": "取消",
    "region": "地區",
    "display": "顯示",
    "selectAll": "全选"
  },
  "it": {
    "selectAll": "seleziona tutto",
    "selectAll2": "Deseleziona tutto"
  },
  "kr": {
    "showName": "지역 이름 보이기",
    "confirm": "확인",
    "cancel": "취소",
    "region": "지역",
    "display": "보이기",
    "selectAll": "全選",
    "selectAll2": "取消全選"
  },
  "kr": {
    "selectAll": "전부 선택",
    "selectAll2": "전부 선택 취소"
  }
}
</i18n>
